import NativeVideoPlayer from './NativeVideoPlayer';

export default NativeVideoPlayer;
export * from './types';
export { NativeVideoPlayer };
